import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TemplateFormSchema } from '@models';
import { map, Observable } from 'rxjs';
import { IntakeFormTemplateService } from './intake-form-template.service';

@Injectable({
  providedIn: 'root',
})
export class IntakeFormTemplateMockService
  implements IntakeFormTemplateService
{
  private http = inject(HttpClient);

  private url = './assets/ui-lib/intake-form.template.json';

  getTemplate(): Observable<TemplateFormSchema> {
    return this.http
      .get<TemplateFormSchema[]>(this.url)
      .pipe(map(templates => templates[0]));
  }
}
